import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-detail-form',
  templateUrl: './project-detail-form.component.html',
  styleUrls: ['./project-detail-form.component.scss']
})
export class ProjectDetailFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
